import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from "react-redux";

function ProductListingProduct(props) {
  const [form, setForm] = useState(
    (props.listingData && props.listingData.formData) || {}
  );
  const oldData = (props.listingData && props.listingData.catalogData) || {};

  useEffect(() => {
    if (props.listingData && props.listingData.formData) {
      setForm(props.listingData.formData);
    }
  }, [props.listingData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = () => {
    props.setListingData((prev) => ({
      ...prev,
      formData: form,
    }));
    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 2 : Product Identification</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Product Name :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.productTitle || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="productTitle"
                  value={form.productTitle || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Brand :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.brand || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="brand"
                  value={form.brand || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                UPC / EAN / GTIN :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.gtin || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="gtin"
                  value={form.gtin || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                SKU :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.sku || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="sku"
                  value={form.sku || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Category :
              </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.category || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="category"
                  value={form.category || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>
          <button className="btn btn-primary" onClick={handleNext}>
            Next →
          </button>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingProduct);